import {FaHeadset, FaPhone, FaEnvelope, FaClock, FaCheckCircle, FaCalendarAlt, FaUserLock, FaCreditCard, FaLaptop} from "react-icons/fa";
import {NavLink} from "react-router-dom";
import {useState} from "react";
import {Modal} from "antd";

export default function HeaderTop() {
    const [isSupportModal, setIsSupportModal] = useState(false);

    const toggleSupportModal = () => {
        setIsSupportModal(!isSupportModal);
    }

    return (
        <>
            <Modal 
                title={null} 
                width={window.innerWidth > 780 ? 700 : "100%"} 
                open={isSupportModal} 
                onCancel={()=> setIsSupportModal(false)} 
                centered  
                destroyOnClose={true} 
                footer={null}
                className="creative-support-modal"
            >
                <div className="support-modal-content">
                    <div className="support-header">
                        <div className="support-icon-wrapper">
                            <FaHeadset className="support-main-icon" />
                            <div className="icon-glow"></div>
                        </div>
                        <h2 className="support-title">How can we help you?</h2>
                        <p className="support-description">
                            Our support team is here to assist you with any questions or concerns you may have.
                        </p>
                    </div>
                    
                    <div className="support-contact-cards">
                        <a href="mailto:info@yjcandwellness.com" className="contact-card email-card">
                            <div className="card-icon-wrapper email-icon">
                                <FaEnvelope />
                            </div>
                            <div className="card-content">
                                <h3>Email Support</h3>
                                <p className="contact-value">info@yjcandwellness.com</p>
                                <span className="card-action">Send us an email →</span>
                            </div>
                        </a>
                        
                        <a href="tel:+14047956474" className="contact-card phone-card">
                            <div className="card-icon-wrapper phone-icon">
                                <FaPhone />
                            </div>
                            <div className="card-content">
                                <h3>Phone Support</h3>
                                <p className="contact-value">+1 404-795-6474</p>
                                <span className="card-action">Call us now →</span>
                            </div>
                        </a>
                        
                        <div className="contact-card hours-card">
                            <div className="card-icon-wrapper hours-icon">
                                <FaClock />
                            </div>
                            <div className="card-content">
                                <h3>Business Hours</h3>
                                <p className="contact-value">Monday - Friday</p>
                                <p className="contact-time">9:00 AM - 6:00 PM EST</p>
                            </div>
                        </div>
                    </div>
                    
                    <div className="common-issues-section">
                        <h4 className="issues-title">
                            <FaCheckCircle className="title-icon" />
                            Common Issues We Help With
                        </h4>
                        <div className="issues-grid">
                            <div className="issue-item">
                                <FaCalendarAlt className="issue-icon" />
                                <span>Appointment scheduling</span>
                            </div>
                            <div className="issue-item">
                                <FaUserLock className="issue-icon" />
                                <span>Account access issues</span>
                            </div>
                            <div className="issue-item">
                                <FaCreditCard className="issue-icon" />
                                <span>Payment & billing</span>
                            </div>
                            <div className="issue-item">
                                <FaLaptop className="issue-icon" />
                                <span>Technical difficulties</span>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <header className="modern-header-top" data-aos="fade-down">
                <div className="header-contact-info">
                    <a href="tel:+14047956474" className="contact-pill phone-pill">
                        <div className="pill-icon-wrapper">
                            <FaPhone className="pill-icon" />
                        </div>
                        <span className="pill-text">404-795-6474</span>
                    </a>
                    <a href="mailto:info@yjcandwellness.com" className="contact-pill email-pill">
                        <div className="pill-icon-wrapper">
                            <FaEnvelope className="pill-icon" />
                        </div>
                        <span className="pill-text">info@yjcandwellness.com</span>
                    </a>
                </div>
                
                <div className="header-center">
                    <div className="welcome-text">
                        <div className="welcome-icon">✨</div>
                        <span className="welcome-gradient">Your Journey to Wellness Starts Here</span>
                        <div className="welcome-icon">✨</div>
                    </div>
                </div>
                
                <div className="header-actions">
                    <div className="header-buttons">
                        <button 
                            type="button"
                            className="support-btn"
                            onClick={toggleSupportModal}
                            aria-label="Contact Support"
                        >
                            <FaHeadset className="btn-icon" />
                            <span>Support</span>
                        </button>
                        
                        {localStorage.getItem("UserId") ? (
                            <NavLink to={'/user/dashboard'} className="dashboard-btn">
                                <span>Dashboard</span>
                            </NavLink>
                        ) : (
                            <NavLink to={'/auth/login'} className="login-btn">
                                <span>Login</span>
                            </NavLink>
                        )}
                    </div>
                </div>
            </header>
        </>
    )
}

